import React from 'react';
import styled from 'styled-components';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

export default function StepRelatedObjectsDropdown(props) {
	const {relatedObjects, triggerItems, handleOnOpen, isOpen, icon, onCancel, toolTipHeader} = props;
    
	const handleOnWheelCapture = (event) => {
		event.stopPropagation();
		event.preventDefault();
	}

	return (
		<StyledMotifDropdownPortal
			//usePortal
			closeOnOutsideClick={false}
			className={'relatedObjectDropdown'}
			placement="bottom-start"
			open={isOpen}
			trigger={triggerItems}
			handleOnClose={() => {
				onCancel();
			}}
			handleOnOpen={handleOnOpen}
		>
			<section className={`relatedObjectDropdown ${''}`} type={'container'} onWheelCapture={(e) => handleOnWheelCapture(e)}>
				<StyledObjectListArea className="objectList">
					<section className="objectListHeading">
						<h2 className="title motif-body1-default-regular motif-dropdown-group-title">{toolTipHeader}</h2>
					</section>
					<ul className="objectListBody listView">
						{relatedObjects?.map((object) => (
							<li key={object.id}>
								<MotifDropdownItem>
									<MotifIcon src={icon} size="20" />
									<span className="listitem motif-body1-default-light">
										<EllipsesControl tooltip={object} content={object} noOfLines={1} />
									</span>
								</MotifDropdownItem>
							</li>
						))}
					</ul>
				</StyledObjectListArea>
			</section>
		</StyledMotifDropdownPortal>
	);
}

const StyledMotifDropdownPortal = styled(MotifDropdown)`
	.relatedObjectDropdown {
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}
`;

const StyledObjectListArea = styled.section`
	&.objectList {
		.objectListHeading {
			.title {
				color: var(--neutrals-900);
				margin: 0;
				padding: var(--px-10) var(--px-14);
			}
		}
		ul.objectListBody {
			li {
				width: 100%;
				.item {
					display: block;
					color: var(--neutrals-900);
				}
			}
		}
	}
`;
